import { getChatbotRoot } from "@src/containers/components/Chatbot";
import {
  generateConversionId,
  generateEventId,
  getEcommerceItemsByIds,
  getPropertyIdFromPage,
} from "./helpers";
import { clearEcommerceObject, gtmDataLayerPush } from "./gtm";
import { sha256Hash } from "@src/utils/hash";

let cachedEcommerceItem:
  | Awaited<ReturnType<typeof getEcommerceItemsByIds>>[0]
  | null = null;

interface IChatbotData {
  event: string;
  name?: string;
  email?: string;
}

// will push "chatbot_initiate" and "chatbot_submission" in chatbot-widget
export const CHATBOT_EVENT_NAME = "chatbot-analytics";

export function setupChatbotEvent() {
  // Pre-fetch ecommerce item data for beforeunload scenario
  const propertyId = getPropertyIdFromPage();
  if (propertyId) {
    getEcommerceItemsByIds([propertyId]).then((items) => {
      cachedEcommerceItem = items[0] ?? null;
    });
  }

  window.addEventListener(CHATBOT_EVENT_NAME, ((
    event: CustomEvent<IChatbotData>
  ) => {
    triggerChatbotEvent(event.detail);
  }) as EventListener);
}

export function triggerChatbotEvent(moreData: IChatbotData) {
  const chatbotEle = getChatbotRoot();
  if (!chatbotEle) return;
  const propertyId = getPropertyIdFromPage();
  const enquiryType = propertyId ? "property_enquiry" : "general_enquiry";
  const data = sessionStorage?.getItem("ga_submission_event");
  const personData = {
    current: {},
  };

  if (moreData.name && moreData.email) {
    personData.current = {
      fn: sha256Hash(moreData.name),
      ln: sha256Hash(moreData.name),
      hashed_email: sha256Hash(moreData.email),
    };
  }

  if (data) {
    const { name, email, phone, budgetPerPerson } = JSON.parse(data);

    personData.current = {
      conversion_id: generateConversionId(),
      fn: sha256Hash(name),
      ln: sha256Hash(name),
      hashed_email: sha256Hash(email),
      hashed_phone: sha256Hash(phone),
      budget_per_person: budgetPerPerson,
    };
  }

  const param = {
    [`event_id_${moreData.event}`]: generateEventId(),
    event: moreData.event,
    enquiry_type: enquiryType,
    ...(moreData.event === "chatbot_submission" ? personData.current : {}),
  };

  if (propertyId && cachedEcommerceItem) {
    clearEcommerceObject();
    gtmDataLayerPush({
      ...cachedEcommerceItem,
      ...param,
    });
  } else {
    gtmDataLayerPush({ ...param });
  }
}
